<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input v-model="listQuery.order_no" placeholder="请输入订单号" class="filter-item" style="width: 220px;" clearable />

      <el-input v-model="listQuery.teacher_card_id" placeholder="请输入教师卡ID" class="filter-item" style="width: 160px;" clearable />

      <el-select filterable multiple collapse-tags v-model="listQuery.shop_ids" placeholder="请选择店铺" class="filter-item" style="width: 220px" clearable>
        <el-option v-for="item in shops" :key="item.id" :label="item.shop_name" :value="item.id"></el-option>
      </el-select>

      <el-input v-model="listQuery.shop_name" placeholder="请输入店铺名称" class="filter-item" style="width: 220px;" clearable />

      <el-select v-model="listQuery.pay_status" placeholder="支付状态" class="filter-item" style="width: 140px;" clearable>
        <el-option label="已支付" :value="1" />
        <el-option label="已退款" :value="2" />
      </el-select>

      <el-select v-model="listQuery.pay_mode" placeholder="消费方式" class="filter-item" style="width: 140px;" clearable>
        <el-option label="收银设备" :value="1" />
        <el-option label="扫码收款" :value="2" />
        <el-option label="堂食支付" :value="3" />
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>

      <download-excel :fields="json_fields" :fetch="handleExport" type="xls" name="教师卡消费记录.xls" worksheet="教师卡消费记录">
        <el-button type="success" :loading="exportLoading">导出</el-button>
      </download-excel>
    </div>

    <div v-loading="listLoading" style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payMoney || 0 }}</div>
            <div class="subtitle">累计消费金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payCount || 0 }}</div>
            <div class="subtitle">累计消费次数</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.refundMoney || 0 }}</div>
            <div class="subtitle">累计退款金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.refundCount || 0 }}</div>
            <div class="subtitle">累计退款次数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.name }}
        </template>
      </el-table-column>

      <el-table-column label="手机号码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.phone }}
        </template>
      </el-table-column>

      <el-table-column label="店铺ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop_id }}
        </template>
      </el-table-column>

      <el-table-column label="店铺名称" min-width="110" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.shop.shop_name }}</div>
        </template>
      </el-table-column>

      <el-table-column label="设备编号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.device_id }}
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.pay_status === 1">已支付</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_status === 2">已退款</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="消费方式" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.pay_mode === 1">收银设备</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_mode === 2">扫码收款</el-tag>
          <el-tag type="primary" v-else-if="scope.row.pay_mode === 3">堂食支付</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="消费金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_money }}
        </template>
      </el-table-column>

      <el-table-column label="消费后卡余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.after_balance }}
        </template>
      </el-table-column>

      <el-table-column label="消费时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="handleTeacherCardOrderCancel(scope.row)" :disabled="!(scope.row.pay_status === 1 && scope.row.created_at >= currentDate && scope.row.pay_mode === 1)">取消订单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import downloadExcel from "vue-json-excel";
var moment = require("moment");

export default {
  components: {
    downloadExcel
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        school_id: "",
        shop_ids: [],
        shop_name: "",
        teacher_card_id: "",
        order_no: "",
        pay_status: "",
        pay_mode: "",
        start_date: "",
        end_date: "",
      },
      shops: [],
      dateArr: null,
      json_fields: {
        订单号: {
          field: "order_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        姓名: "user.name",
        手机号码: {
          field: "user.phone",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        店铺ID: {
          field: "shop_id",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        店铺名称: "shop.shop_name",
        设备编号: {
          field: "device_id",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        支付状态: {
          field: "pay_status",
          callback: (value) => {
            if (value === 1) return "已支付";
            else if (value === 2) return "已退款";
            else return "";
          }
        },
        消费方式: {
          field: "pay_mode",
          callback: (value) => {
            if (value === 1) return "收银设备";
            else if (value === 2) return "扫码收款";
            else if (value === 3) return "堂食支付";
            else return "";
          }
        },
        消费金额: "pay_money",
        消费后卡余额: "after_balance",
        消费时间: {
          field: "created_at",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
      },
      exportLoading: false,
      payMoney: null,
      payCount: null,
      refundMoney: null,
      refundCount: null,
      currentDate: null
    };
  },
  created() {
    if (this.$route.query.teacher_card_id) {
      this.listQuery.teacher_card_id = parseInt(this.$route.query.teacher_card_id);
    }
    this.currentDate = moment().format("YYYY-MM-DD 00:00:00");
    this.getList();
    this.getShopList();
  },
  computed: {
    ...mapGetters(["schools", "school_id", "user"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
      this.getShopList();
    },
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_date = newVal[0];
        this.listQuery.end_date = newVal[1];
      } else {
        this.listQuery.start_date = "";
        this.listQuery.end_date = "";
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/teacherCard/order",
        method: "get",
        params: this.listQuery,
        timeout: 6000000,
      }).then((response) => {
        this.list = response.data.list.data;
        this.total = response.data.list.total;
        this.payMoney = response.data.payMoney;
        this.payCount = response.data.payCount;
        this.refundMoney = response.data.refundMoney;
        this.refundCount = response.data.refundCount;
        this.listLoading = false;
      });
    },
    getShopList() {
      request({
        url: "/api/backend/shop/list",
        method: "get",
        params: {
          page: 1,
          limit: 1000000,
          school_id: this.school_id,
        }
      }).then(response => {
        this.shops = response.data.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleExport() {
      if (!this.listQuery.start_date || !this.listQuery.end_date) {
        this.$message({
          type: "warning",
          message: "请选择时间段"
        });
        return;
      }

      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.page = 1;
      listQuery.limit = this.total;
      this.exportLoading = true;
      return request({
        url: "/api/backend/teacherCard/order",
        method: "get",
        params: listQuery,
        timeout: 6000000,
      }).then(response => {
        if (response.data.list.data.length <= 0) {
          this.$message({
            type: "warning",
            message: "暂无记录"
          });
          return;
        }
        return response.data.list.data;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    handleTeacherCardOrderCancel(item){
      this.$confirm("确认继续该操作？", "提示", {
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/teacherCard/orderCancel",
          method: "post",
          data: {
            order_no: item.order_no
          }
        }).then(() => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.getList();
        });
      });
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
</style>
